'use es6';

import getIn from 'transmute/getIn';
import Raven from 'raven-js';
import { BOT as BOT_SENDER_TYPE } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { HUMAN as HUMAN_AGENT_TYPE, BOT as BOT_AGENT_TYPE } from 'conversations-message-history/common-message-format/constants/agentTypes';
import { prepareThreadHistoryResponse } from '../operators/prepareThreadHistoryResponse';
import { getSenderPairs } from '../operators/getSenderPairs';
import { fetchAgentResponderIfNecessary } from '../../actions/AgentResponderActions';
import { dataFetchingClient } from '../../data-fetching-client/dataFetchingClient';
import { FETCH_THREAD_HISTORY_QUERY } from '../hooks/useFetchThreadHistory';
import { threadHistoryFetchStarted, threadHistoryFetched, threadHistoryFetchFailed, threadHistoryFilesReceived } from '../constants/ActionTypes';
export function fetchThreadHistory({
  offsetOrdinal,
  offsetTimestamp,
  threadId,
  sessionId
}) {
  return dispatch => {
    if (!threadId) {
      return Promise.resolve();
    }
    dispatch(threadHistoryFetchStarted({
      threadId
    }));
    return dataFetchingClient.query({
      query: FETCH_THREAD_HISTORY_QUERY,
      variables: {
        offsetOrdinal,
        offsetTimestamp,
        threadId,
        sessionId
      }
    }).then(result => {
      const {
        threadHistory,
        files,
        hasVisitorEmail
      } = prepareThreadHistoryResponse(result.data.fetchThreadHistory);
      const responders = getSenderPairs(threadHistory);
      dispatch(threadHistoryFetched({
        threadId,
        threadHistory,
        hasVisitorEmail
      }));
      dispatch(threadHistoryFilesReceived({
        files
      }));
      responders.forEach(senderPair => {
        const senderId = getIn(['senderId'], senderPair);
        const senderType = getIn(['senderType'], senderPair);
        const agentType = senderType === BOT_SENDER_TYPE ? BOT_AGENT_TYPE : HUMAN_AGENT_TYPE;
        dispatch(fetchAgentResponderIfNecessary({
          senderId,
          agentType
        }));
      });
    }).catch(error => {
      dispatch(threadHistoryFetchFailed({
        threadId
      }));
      Raven.captureException(error);
    });
  };
}